import httpService from './http.service';

const getUsersForSubject = (subjectId) => httpService
    .get(`/extusers/subject/${subjectId}`)
    .then(({data}) => data)
    .catch((err) => Promise.reject(err.response));

const getUsersAll = () => httpService
    .get(`/extuser/all`)
    .then(({data}) => data)
    .catch((err) => Promise.reject(err.response));

const getUsersAllByRole = (roleId) => httpService
    .get(`/extuser/all/role/${roleId}`)
    .then(({data}) => data)
    .catch((err) => Promise.reject(err.response));

const createUser = (user) => httpService
    .post(`/extuser/create`, user)
    .then(({data}) => data)
    .catch((err) => {
        throw err;
    });

const updateUser = (user) => httpService
    .put(`/extuser/update`, user)
    .then(({data}) => data)
    .catch((err) => Promise.reject(err));

const updateUserState = (userId, active) => httpService
    .put(`/extuser/${userId}?active=${active}`)
    .then()
    .catch((err) => Promise.reject(err));

const synchUser = (user, parkingIds) => httpService
    .put(`/extuser/synch?parkingIds=${parkingIds}`, user)
    .then(({data}) => data)
    .catch((err) => Promise.reject(err));

export default {
    getUsersForSubject,
    getUsersAll,
    getUsersAllByRole,
    createUser,
    updateUser,
    updateUserState,
    synchUser
};
